// extracted by mini-css-extract-plugin
export default {"inputContainer":"DomainInputForm_inputContainer__UaKdN","formControl":"DomainInputForm_formControl__aWnHc","input-group-dropdown-2":"DomainInputForm_input-group-dropdown-2__2sDAo"};